export function isTType(input) {
    return typeof input !== 'string';
}
export function isRequest(input) {
    return notNullOrUndefined(input.url);
}
//type guards for LoadOptions
function notNullOrUndefined(value) {
    return value !== null && value !== undefined;
}
export const isLoadOptionsBrowser = (options) => {
    return notNullOrUndefined(options.serverUrl);
};
export const isLoadOptionsRemote = (options) => {
    return notNullOrUndefined(options.fetchFunction);
};
export const isErrorWithMessage = (e) => {
    return notNullOrUndefined(e.message);
};
